import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['content', 'button']

  copyToClipboard() {
    this.contentTarget.select();
    this.contentTarget.setSelectionRange(0, 99999);
    document.execCommand('copy');
    this.buttonTarget.innerHTML = 'Copied!';
    setTimeout(() => { this.buttonTarget.innerHTML = 'Copy'; }, 3000);
  }
}
